export default __webpack_public_path__ + "static/media/IBMDelete.cbf9a706.svg";